// OdorBlitz Shopify Theme — Optimized JS
// ─────────────────────────────────────────────────────────────────
// PRODUCT VARIANT IDs — PASTE YOUR SHOPIFY VARIANT IDs BELOW
// To find a variant ID: Shopify Admin → Products → your product
// → click a variant → copy the number at the end of the URL
// ─────────────────────────────────────────────────────────────────
var ODORBLITZ_VARIANTS = {
  '1room':   '10197011923227',  // 1 Room Kit         — $38.99
  'bulk':    '10200758255899',  // Bulk Tablets 20pk  — $89.99
  'bubbler': '10200759238939',  // OdorBlitz Bubbler  — $22.99
  'pod':     '10200759927067'   // Air Relief Pod 2pk — $24.99
};
// ─────────────────────────────────────────────────────────────────

// ─── Dark Mode — apply BEFORE paint to avoid flash ──────────────
(function () {
  var saved = localStorage.getItem('ob-dark');
  if (saved === 'true') {
    document.body && document.body.classList.add('dark');
  }
})();

document.addEventListener('DOMContentLoaded', function () {

  // ─── Dark Mode Init ─────────────────────────────────────────────
  var saved = localStorage.getItem('ob-dark');
  var isDark = saved === 'true';
  if (isDark) document.body.classList.add('dark');

  var darkBtn = document.getElementById('ob-dark-toggle');
  var darkIcon = document.getElementById('ob-dark-icon');
  var darkBtnMobile = document.getElementById('ob-dark-toggle-mobile');
  var darkIconMobile = document.getElementById('ob-dark-icon-mobile');

  function updateDarkIcon() {
    var d = document.body.classList.contains('dark');
    if (darkIcon) darkIcon.textContent = d ? '☀️' : '🌙';
    if (darkBtn) darkBtn.title = d ? 'Switch to Light Mode' : 'Switch to Dark Mode';
    if (darkIconMobile) darkIconMobile.textContent = d ? '☀️' : '🌙';
    if (darkBtnMobile) darkBtnMobile.title = d ? 'Switch to Light Mode' : 'Switch to Dark Mode';
  }
  updateDarkIcon();

  function toggleDark() {
    document.body.classList.toggle('dark');
    localStorage.setItem('ob-dark', document.body.classList.contains('dark') ? 'true' : 'false');
    updateDarkIcon();
  }
  if (darkBtn) darkBtn.addEventListener('click', toggleDark);
  if (darkBtnMobile) darkBtnMobile.addEventListener('click', toggleDark);

  // ─── FAQ Accordion ─────────────────────────────────────────────
  document.querySelectorAll('.faq-item').forEach(function (item) {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    const icon = item.querySelector('.faq-icon');
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      const isOpen = answer.classList.contains('open');
      document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
      document.querySelectorAll('.faq-question').forEach(b => b.setAttribute('aria-expanded', 'false'));
      document.querySelectorAll('.faq-icon').forEach(i => { if (i) i.textContent = '+'; });
      if (!isOpen) {
        answer.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        if (icon) icon.textContent = '−';
      }
    });
  });

  // ─── Pricing Option Selection ───────────────────────────────────
  const pricingOptions = document.querySelectorAll('.pricing-option');
  const selectedPriceEl = document.getElementById('selected-price');

  var VARIANT_NAME_MAP = {
    'OdorBlitz Bomb':        '1room',
    'Bulk Tablets — 20 Pack': 'bulk',
    'OdorBlitz Bubbler':     'bubbler',
    'Air Relief Pod 2 Pack': 'pod'
  };

  function getSelectedVariantId() {
    const active = document.querySelector('.pricing-option.popular');
    if (!active) return null;
    const fromAttr = active.dataset.variantId;
    if (fromAttr && fromAttr.length > 5) return fromAttr;
    const key = VARIANT_NAME_MAP[active.dataset.name];
    return key ? (ODORBLITZ_VARIANTS[key] || null) : null;
  }

  function getQty() {
    const el = document.getElementById('qty-value');
    return el ? parseInt(el.textContent, 10) || 1 : 1;
  }

  // ─── Cart URL builder — uses Shopify's /cart/VARIANT:QTY route ──
  function goToCart(variantId, quantity) {
    if (!variantId || String(variantId).indexOf('PASTE') !== -1) {
      alert('Product not linked yet — variant ID is missing.');
      return;
    }
    window.location.href = '/cart/' + variantId + ':' + (quantity || 1);
  }

  // ─── Pricing Option Click ───────────────────────────────────────
  pricingOptions.forEach(function (opt) {
    opt.addEventListener('click', function () {
      pricingOptions.forEach(o => o.classList.remove('popular'));
      opt.classList.add('popular');
      if (selectedPriceEl) selectedPriceEl.textContent = opt.dataset.price || '';
    });
  });

  // ─── Main Add to Cart Button ────────────────────────────────────
  const mainBtn = document.getElementById('main-add-to-cart');
  if (mainBtn) {
    mainBtn.addEventListener('click', function () {
      goToCart(getSelectedVariantId(), getQty());
    });
  }

  // ─── Upsell "Add Bubbler" Button ───────────────────────────────
  var upsellBtn = document.getElementById('upsell-bundle-btn');
  if (upsellBtn) {
    upsellBtn.addEventListener('click', function () {
      var target = document.querySelector('.pricing-option[data-name="OdorBlitz Bubbler"]');
      if (target) {
        pricingOptions.forEach(function (o) { o.classList.remove('popular', 'selected'); });
        target.classList.add('popular', 'selected');
        if (selectedPriceEl) selectedPriceEl.textContent = target.dataset.price || '$22.99';
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        target.style.outline = '3px solid #CC1100';
        setTimeout(function () { target.style.outline = ''; }, 1200);
      }
    });
  }

  // ─── Quantity Selector ──────────────────────────────────────────
  const qtyValue = document.getElementById('qty-value');
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus  = document.getElementById('qty-plus');
  let qty = 1;

  if (qtyMinus && qtyPlus && qtyValue) {
    qtyMinus.addEventListener('click', function () {
      if (qty > 1) { qty--; qtyValue.textContent = qty; }
    });
    qtyPlus.addEventListener('click', function () {
      if (qty < 10) { qty++; qtyValue.textContent = qty; }
    });
  }

  // ─── Smooth Scroll ──────────────────────────────────────────────
  document.querySelectorAll('a[href="#buy"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById('buy');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Urgency countdown timer removed — not permitted under GMC policy


  // ─── Review Slider ──────────────────────────────────────────────
  (function () {
    var slides = document.querySelectorAll('.ob-review-slide');
    var dots = document.querySelectorAll('#ob-review-dots .review-dot');
    var track = document.getElementById('ob-review-track');
    var prevBtn = document.getElementById('ob-review-prev');
    var nextBtn = document.getElementById('ob-review-next');
    if (!slides.length || !track) return;

    var current = 0;
    var total = slides.length;
    var animating = false;
    var autoTimer = null;

    function showSlide(next, direction) {
      if (animating || next === current) return;
      animating = true;
      track.classList.add('exit-' + direction);
      setTimeout(function () {
        slides[current].style.display = 'none';
        slides[current].classList.remove('active');
        if (dots[current]) dots[current].classList.remove('active');
        current = (next + total) % total;
        slides[current].style.display = 'block';
        slides[current].classList.add('active');
        if (dots[current]) dots[current].classList.add('active');
        track.classList.remove('exit-left', 'exit-right');
        animating = false;
      }, 320);
    }

    function startAuto() {
      autoTimer = setInterval(function () {
        showSlide(current + 1, 'left');
      }, 4500);
    }

    function resetAuto() {
      clearInterval(autoTimer);
      startAuto();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1, 'right'); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1, 'left'); resetAuto(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        showSlide(i, i > current ? 'left' : 'right');
        resetAuto();
      });
    });

    startAuto();
  })();

  // ─── Floating Cart + Qty Modal ──────────────────────────────
  var cartBadge = document.getElementById('ob-cart-badge');
  var qtyModal  = document.getElementById('ob-qty-modal');
  var modalQtyEl = document.getElementById('ob-modal-qty');
  var modalQty = 1;
  var activeVariant = null;
  var activeFallbackUrl = null;

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.style.display = count > 0 ? 'flex' : 'none';
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(d) { updateCartBadge(d.item_count); })
      .catch(function() {});
  }

  // Initialize badge on page load
  fetchCartCount();

  // Restore scroll position + show toast after add-to-cart page reload
  (function() {
    try {
      var justAdded = sessionStorage.getItem('ob_just_added');
      var savedY    = parseInt(sessionStorage.getItem('ob_scroll_y') || '0', 10);
      if (justAdded) {
        sessionStorage.removeItem('ob_just_added');
        sessionStorage.removeItem('ob_scroll_y');
        // Scroll back immediately (browser may have already scrolled to top)
        if (savedY > 0) {
          // Try instantly first, then again after images/layout settle
          window.scrollTo(0, savedY);
          setTimeout(function() { window.scrollTo(0, savedY); }, 100);
          setTimeout(function() { window.scrollTo(0, savedY); }, 400);
        }
        // Show toast once scroll is restored
        setTimeout(function() { showToast(justAdded); }, 420);
      }
    } catch(e) {}
  })();

  var activePrice = '';

  function openQtyModal(btn) {
    if (!qtyModal) return;
    // Prefer data-variant attr; fall back to hardcoded ODORBLITZ_VARIANTS by product name
    activeVariant = (btn.dataset.variant && btn.dataset.variant.length > 3) ? btn.dataset.variant : null;
    if (!activeVariant) {
      var nameKey = VARIANT_NAME_MAP[btn.dataset.name];
      if (nameKey) activeVariant = ODORBLITZ_VARIANTS[nameKey] || null;
    }
    activeFallbackUrl = btn.dataset.url || '#';
    activePrice = btn.dataset.price || '';
    modalQty = 1;
    if (modalQtyEl) modalQtyEl.textContent = '1';
    var nameEl    = document.getElementById('ob-modal-name');
    var priceEl   = document.getElementById('ob-modal-price');
    var imgEl     = document.getElementById('ob-modal-img');
    var confirmEl = document.getElementById('ob-modal-confirm');
    if (nameEl)    nameEl.textContent  = btn.dataset.name  || '';
    if (priceEl)   priceEl.textContent = activePrice;
    if (imgEl)     { imgEl.src = btn.dataset.img || ''; imgEl.alt = btn.dataset.name || ''; }
    if (confirmEl) { confirmEl.textContent = 'Add 1 to Cart — ' + activePrice; confirmEl.disabled = false; confirmEl.style.opacity = ''; }
    qtyModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeQtyModal() {
    if (!qtyModal) return;
    qtyModal.style.display = 'none';
    document.body.style.overflow = '';
    activeVariant = null;
    activePrice = '';
  }

  function updateModalQty(newQty) {
    modalQty = Math.min(10, Math.max(1, newQty));
    if (modalQtyEl) modalQtyEl.textContent = modalQty;
    var confirmEl = document.getElementById('ob-modal-confirm');
    if (confirmEl) confirmEl.textContent = 'Add ' + modalQty + ' to Cart — ' + activePrice;
  }

  // ─── Toast notification ─────────────────────────────────────────
  var toastEl = (function() {
    var el = document.createElement('div');
    el.id = 'ob-toast';
    el.style.cssText = [
      'position:fixed', 'bottom:28px', 'left:50%',
      'transform:translateX(-50%) translateY(12px)',
      'background:#003087', 'color:#fff',
      'padding:13px 22px', 'border-radius:10px',
      'font-size:15px', 'font-weight:600',
      'z-index:20000', 'opacity:0',
      'transition:opacity .25s,transform .25s',
      'pointer-events:none', 'white-space:nowrap',
      'box-shadow:0 4px 18px rgba(0,0,0,.22)'
    ].join(';');
    document.body.appendChild(el);
    return el;
  })();

  var toastTimer = null;
  function showToast(name) {
    clearTimeout(toastTimer);
    toastEl.innerHTML = '&#10003; ' + (name || 'Item') + ' added &nbsp;<a href="/cart" style="color:#f59e0b;font-weight:700;text-decoration:underline;pointer-events:all;">View Cart</a>';
    toastEl.style.opacity = '1';
    toastEl.style.transform = 'translateX(-50%) translateY(0)';
    toastEl.style.pointerEvents = 'auto';
    toastTimer = setTimeout(function() {
      toastEl.style.opacity = '0';
      toastEl.style.transform = 'translateX(-50%) translateY(12px)';
      toastEl.style.pointerEvents = 'none';
    }, 3000);
  }

  function doAddToCart() {
    if (!activeVariant) {
      window.location.href = activeFallbackUrl || '#';
      closeQtyModal();
      return;
    }
    var confirmEl = document.getElementById('ob-modal-confirm');
    if (confirmEl) { confirmEl.textContent = 'Adding…'; confirmEl.disabled = true; confirmEl.style.opacity = '0.7'; }

    var productName = (document.getElementById('ob-modal-name') || {}).textContent || 'Item';

    // Save name + scroll position so we can restore both after the page reloads
    try {
      sessionStorage.setItem('ob_just_added', productName);
      sessionStorage.setItem('ob_scroll_y', String(window.scrollY || window.pageYOffset || 0));
    } catch(e) {}

    // Form POST — proven to work; return_to brings customer back to this page
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';

    function h(name, val) {
      var el = document.createElement('input');
      el.type = 'hidden'; el.name = name; el.value = val;
      form.appendChild(el);
    }
    h('id',        String(activeVariant));
    h('quantity',  String(modalQty));
    h('return_to', window.location.pathname + window.location.search);

    document.body.appendChild(form);
    form.submit();
  }

  document.querySelectorAll('.ob-atc').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openQtyModal(btn);
    });
  });

  var minusBtn   = document.getElementById('ob-modal-minus');
  var plusBtn    = document.getElementById('ob-modal-plus');
  var cancelBtn  = document.getElementById('ob-modal-cancel');
  var confirmBtn = document.getElementById('ob-modal-confirm');
  var closeBtn   = document.getElementById('ob-modal-close');

  if (minusBtn)   minusBtn.addEventListener('click',   function() { updateModalQty(modalQty - 1); });
  if (plusBtn)    plusBtn.addEventListener('click',    function() { updateModalQty(modalQty + 1); });
  if (cancelBtn)  cancelBtn.addEventListener('click',  closeQtyModal);
  if (closeBtn)   closeBtn.addEventListener('click',   closeQtyModal);
  if (confirmBtn) confirmBtn.addEventListener('click', doAddToCart);

  if (qtyModal) {
    qtyModal.addEventListener('click', function(e) {
      if (e.target === qtyModal) closeQtyModal();
    });
  }

  // ─── Lazy Load Images ───────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImages.forEach(img => observer.observe(img));
  }

});


/* ═══════════════════════════════════════════════════════════════════
   ODORBLITZ CINEMATIC ENGINE v3.0
   Scroll reveals · Parallax · Vapor canvas · Mouse parallax
   Counters · Split text · Scroll progress · Stagger grids
   Applies globally to every page, every section
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── 2. SCROLL REVEAL ENGINE ─────────────────────────────────── */
  function initScrollReveal() {
    /* Selectors that get auto-tagged for reveal on every page */
    var AUTO_TAG = [
      '.section-title','.ob-eyebrow','.ob-odors__eyebrow','.ob-odors__title',
      '.ob-odors__sub','.ob-hiw__eyebrow','.ob-hiw__title','.ob-hiw__sub',
      '.ob-pain__eyebrow','.ob-pain__title','.ob-pain__sub','.ob-pain__body',
      '.ob-faq__eyebrow','.ob-faq__title',
      '.ob-final-cta__eyebrow','.ob-final-cta__title','.ob-final-cta__sub',
      '.ob-hero__trust',
      '.claims-headline','.claims-body',
      '.product-title','.product-subtitle','.product-reviews',
      '.ob-reviews-badge',
      'h2:not(.ob-hero__headline):not(.ob-pain__title):not(.ob-hiw__title)',
      'h3:not(.ob-hiw__step-title)',
      '.btn-primary:not(.ob-hero__btn-primary)',
      '.btn-add-cart',
      '.ob-pain__col-title',
      '.ob-pain__vs'
    ];

    AUTO_TAG.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.hasAttribute('data-ob-anim')) el.setAttribute('data-ob-anim', 'up');
        });
      } catch(e) {}
    });

    /* Stagger grids — children get sequential delays */
    var STAGGER_PARENTS = [
      '.ob-odors__grid','.features-strip-inner','.ob-hiw__steps',
      '.ob-hiw__stats','.ob-pain__cards','.pricing-options',
      '.faq-list .ob-faq__item','.ob-final-cta__proof'
    ];
    STAGGER_PARENTS.forEach(function (sel) {
      try {
        var parent = document.querySelector(sel);
        if (!parent) return;
        var kids = sel.indexOf(' ') > -1
          ? document.querySelectorAll(sel)
          : parent.children;
        Array.from(kids).forEach(function (child, i) {
          if (!child.hasAttribute('data-ob-anim')) {
            child.setAttribute('data-ob-anim', 'up');
            child.setAttribute('data-ob-delay', String(i * 90));
          }
        });
      } catch(e) {}
    });

    /* Single items with left/right reveals */
    var LEFT_SELECTORS  = ['.claims-image-panel','.ob-pain__img-wrap','.ob-exp__before'];
    var RIGHT_SELECTORS = ['.claims-text-panel','.ob-exp__after'];
    LEFT_SELECTORS.forEach(function(s){
      try { document.querySelectorAll(s).forEach(function(el){
        if(!el.hasAttribute('data-ob-anim')) el.setAttribute('data-ob-anim','left');
      }); } catch(e) {}
    });
    RIGHT_SELECTORS.forEach(function(s){
      try { document.querySelectorAll(s).forEach(function(el){
        if(!el.hasAttribute('data-ob-anim')) el.setAttribute('data-ob-anim','right');
      }); } catch(e) {}
    });

    /* Also auto-tag review cards, pricing cards, how-cards */
    ['.review-card','.how-card','.ob-odors__card','.ob-hiw__step',
     '.ob-hiw__stat','.ob-pain__card','.ob-det__stat',
     '.features-strip-item'].forEach(function(s){
      try { document.querySelectorAll(s).forEach(function(el){
        if(!el.hasAttribute('data-ob-anim')) el.setAttribute('data-ob-anim','up');
      }); } catch(e) {}
    });

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-ob-anim]').forEach(function(el){
        el.classList.add('ob-anim-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-ob-delay') || '0', 10);
        setTimeout(function () { el.classList.add('ob-anim-visible'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -50px 0px', threshold: 0.08 });

    document.querySelectorAll('[data-ob-anim]').forEach(function (el) { io.observe(el); });
  }

  /* ── 3. VAPOR / PARTICLE CANVAS ──────────────────────────────── */
  function initVaporCanvas() {
    var canvas = document.getElementById('ob-vapor-canvas');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var W, H, particles = [], RAF;

    function resize() {
      W = canvas.width  = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    }
    resize();

    var resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resize, 200);
    }, { passive: true });

    function Particle() { this.reset(true); }
    Particle.prototype.reset = function (initial) {
      this.x = Math.random() * W;
      this.y = initial ? Math.random() * H : H + 60;
      this.r = Math.random() * 55 + 25;
      this.vx = (Math.random() - 0.5) * 0.4;
      this.vy = -(Math.random() * 0.9 + 0.3);
      this.life = initial ? Math.random() * 180 : 0;
      this.maxLife = Math.random() * 220 + 120;
      this.maxOpacity = Math.random() * 0.07 + 0.02;
      this.hue = Math.random() < 0.6 ? '204,17,0' : '204,17,0';
    };
    Particle.prototype.tick = function () {
      this.x += this.vx; this.y += this.vy; this.life++;
      var ratio = this.life / this.maxLife;
      this.opacity = ratio < 0.25
        ? (ratio / 0.25) * this.maxOpacity
        : ratio > 0.75
          ? ((1 - ratio) / 0.25) * this.maxOpacity
          : this.maxOpacity;
      if (this.life >= this.maxLife) this.reset(false);
    };
    Particle.prototype.draw = function () {
      var g = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.r);
      g.addColorStop(0, 'rgba(' + this.hue + ',' + this.opacity + ')');
      g.addColorStop(1, 'rgba(' + this.hue + ',0)');
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
      ctx.fillStyle = g;
      ctx.fill();
    };

    for (var i = 0; i < 50; i++) particles.push(new Particle());

    /* Pause when hero not visible to save CPU */
    var heroVisible = true;
    if ('IntersectionObserver' in window) {
      var heroIO = new IntersectionObserver(function(e){
        heroVisible = e[0].isIntersecting;
        if (heroVisible && !RAF) loop();
      }, { threshold: 0 });
      heroIO.observe(canvas);
    }

    function loop() {
      RAF = requestAnimationFrame(loop);
      if (!heroVisible) { cancelAnimationFrame(RAF); RAF = null; return; }
      ctx.clearRect(0, 0, W, H);
      particles.forEach(function(p){ p.tick(); p.draw(); });
    }
    loop();
  }

  /* ── 4. HERO MOUSE PARALLAX ──────────────────────────────────── */
  function initMouseParallax() {
    var hero = document.querySelector('.ob-hero');
    var wrap = document.querySelector('.ob-hero__image-wrap');
    var orb  = document.querySelector('.ob-hero__orb');
    if (!hero || !wrap) return;

    var tx = 0, ty = 0, cx = 0, cy = 0;
    var raf = null;

    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left - r.width / 2) / r.width;
      ty = (e.clientY - r.top  - r.height / 2) / r.height;
    }, { passive: true });

    hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; });

    function tick() {
      raf = requestAnimationFrame(tick);
      cx += (tx - cx) * 0.06;
      cy += (ty - cy) * 0.06;
      wrap.style.transform = 'translate(' + (cx * 22) + 'px,' + (cy * 12) + 'px)';
      if (orb) orb.style.transform = 'translate(calc(-50% + ' + (cx * -30) + 'px), calc(-50% + ' + (cy * -20) + 'px))';
    }
    tick();
  }

  /* ── 5. PARALLAX ON SCROLL ───────────────────────────────────── */
  function initParallax() {
    var items = document.querySelectorAll('[data-ob-parallax]');
    if (!items.length) return;
    var ticking = false;

    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      items.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-ob-parallax') || '0.2');
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ── 6. ANIMATED COUNTERS ────────────────────────────────────── */
  function initCounters() {
    /* Support both [data-ob-count] and [data-count-up] as aliases */
    var counters = document.querySelectorAll('[data-ob-count], [data-count-up]');
    if (!counters.length || !('IntersectionObserver' in window)) return;

    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-ob-count') || el.getAttribute('data-count-up') || '0');
        var suffix = el.getAttribute('data-ob-suffix') || '';
        var prefix = el.getAttribute('data-ob-prefix') || '';
        var dec    = parseInt(el.getAttribute('data-ob-dec') || '0', 10);
        var dur    = 1600;
        var start  = performance.now();

        function step(now) {
          var p = Math.min((now - start) / dur, 1);
          var ease = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (target * ease).toFixed(dec) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        countIO.unobserve(el);
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) { countIO.observe(el); });
  }

  /* ── 7. SPLIT-WORD HEADLINE REVEAL ──────────────────────────── */
  function initSplitText() {
    document.querySelectorAll('[data-ob-split]').forEach(function (el) {
      var words = el.innerHTML.split(/(<[^>]+>|\s+)/g).filter(Boolean);
      var html = words.map(function (w, i) {
        if (w.trim() === '' || w.startsWith('<')) return w;
        return '<span class="ob-word" style="display:inline-block;opacity:0;transform:translateY(24px);transition:opacity 0.55s ' + (i * 60) + 'ms cubic-bezier(0.25,0.46,0.45,0.94),transform 0.55s ' + (i * 60) + 'ms cubic-bezier(0.25,0.46,0.45,0.94)">' + w + '</span>';
      }).join('');
      el.innerHTML = html;
      el.style.opacity = '1';

      if (!('IntersectionObserver' in window)) {
        el.querySelectorAll('.ob-word').forEach(function(w){
          w.style.opacity = '1'; w.style.transform = 'none';
        });
        return;
      }

      var splitIO = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        el.querySelectorAll('.ob-word').forEach(function (w) {
          w.style.opacity = '1';
          w.style.transform = 'translateY(0)';
        });
        splitIO.unobserve(el);
      }, { threshold: 0.3 });
      splitIO.observe(el);
    });
  }

  /* ── 8. SMOOTH ANCHOR SCROLL (all #hash links) ───────────────── */
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── 9. PRICING CARD 3D TILT ─────────────────────────────────── */
  function initCardTilt() {
    var cards = document.querySelectorAll('.pricing-option, .ob-odors__card, .how-card, .ob-det__stat');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width  - 0.5;
        var y = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transform = 'translateY(-6px) perspective(600px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 6) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ── 10. SECTION LINE REVEAL ─────────────────────────────────── */
  function initLineReveals() {
    if (!('IntersectionObserver' in window)) return;
    var lineIO = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('ob-line-visible');
          lineIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.ob-title-line, .ob-divider-line').forEach(function(el){
      lineIO.observe(el);
    });
  }

  /* ── INIT ALL ────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    /* Small timeout so DOM is fully painted */
    setTimeout(function () {
      initScrollReveal();
      initVaporCanvas();
      initMouseParallax();
      initParallax();
      initCounters();
      initSplitText();
      initSmoothAnchors();
      initCardTilt();
      initLineReveals();
    }, 80);
  }

})();
